import { Link } from 'gatsby';
import { EuiButton, EuiSpacer } from '@elastic/eui';
import YoutubeVideo01 from "components/Internet_Access/Port_Forwarding/TP-Link/YoutubeVideoCardForwarding";
import YoutubeVideo02 from "components/Internet_Access/Port_Forwarding/TP-Link/YoutubeVideoCardForwardingOld";
import NavButtons from 'components/Internet_Access/Port_Forwarding/NavButtons';
import ForumBox from 'components/Internet_Access/Port_Forwarding/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiButton,
  EuiSpacer,
  YoutubeVideo01,
  YoutubeVideo02,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};